import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const irReasonsSlice = createSlice({
  name: "irReasons",
  initialState,
  reducers,
});

